import {
  useMainNavigationItems,
  useAdminNavigationItems,
  useIsAdminRoute,
} from './hooks';

import type { NavigationItem } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

export const useNavigationItemsConfig = (): NavigationItem[] => {
  const isAdminRoute = useIsAdminRoute();
  const adminNavigationItems = useAdminNavigationItems();
  const mainNavigationItems = useMainNavigationItems();

  if (isAdminRoute) {
    return adminNavigationItems;
  }

  return mainNavigationItems;
};
